import { createContentBlock, createSubContent } from "@/lib/text-utils";

export const content = [
  // INFORMATION WE COLLECT
  createContentBlock(
    "Information We Collect",
    "We have collected the following categories of personal information from consumers within the last twelve (12) months:",
    [
      createSubContent({
        title: "",
        html: `
        <table class="min-w-full border-collapse border border-gray-300 mb-4">
          <tr class="bg-gray-100">
            <th class="border border-gray-300 p-2 text-left">Category</th>
            <th class="border border-gray-300 p-2 text-left">Examples</th>
            <th class="border border-gray-300 p-2 text-left">Collected</th>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">A. Identifiers</td>
            <td class="border border-gray-300 p-2">Name, address, email address, phone number, account name, IP address, or other similar identifiers.</td>
            <td class="border border-gray-300 p-2">YES</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">B. Personal information categories listed in the California Customer Records statute</td>
            <td class="border border-gray-300 p-2">Name, address, telephone number, credit card number, debit card number, or financial information.</td>
            <td class="border border-gray-300 p-2">YES</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">C. Protected classification characteristics under California or federal law</td>
            <td class="border border-gray-300 p-2">Age, race, citizenship, marital status, sex, veteran or military status.</td>
            <td class="border border-gray-300 p-2">NO</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">D. Commercial information</td>
            <td class="border border-gray-300 p-2">Records of products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.</td>
            <td class="border border-gray-300 p-2">YES</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">E. Biometric information</td>
            <td class="border border-gray-300 p-2">Genetic, physiological, behavioral, biological characteristics, or identifying information, such as fingerprints, retina scans, or voice recordings.</td>
            <td class="border border-gray-300 p-2">NO</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">F. Internet or other similar network activity</td>
            <td class="border border-gray-300 p-2">Browsing history, search history, information on a consumer's interaction with a website, application, or advertisement.</td>
            <td class="border border-gray-300 p-2">YES</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">G. Geolocation data</td>
            <td class="border border-gray-300 p-2">Physical location or movements.</td>
            <td class="border border-gray-300 p-2">YES</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">H. Sensory data</td>
            <td class="border border-gray-300 p-2">Audio, electronic, visual, thermal, olfactory, or similar information.</td>
            <td class="border border-gray-300 p-2">NO</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">I. Professional or employment-related information</td>
            <td class="border border-gray-300 p-2">Current or past job history or performance evaluations.</td>
            <td class="border border-gray-300 p-2">YES (business customers only)</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">J. Non-public education information</td>
            <td class="border border-gray-300 p-2">Education records directly related to a student maintained by an educational institution.</td>
            <td class="border border-gray-300 p-2">NO</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">K. Inferences drawn from other personal information</td>
            <td class="border border-gray-300 p-2">Profile reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.</td>
            <td class="border border-gray-300 p-2">YES</td>
          </tr>
        </table>
        `,
        sectionId: "1",
      }),
    ],
    undefined,
    1
  ),

  // SOURCES OF PERSONAL INFORMATION
  createContentBlock(
    "Sources of Personal Information",
    "We obtain the categories of personal information listed above from the following categories of sources:",
    [
      createSubContent({
        title: "",
        html: `
        <ul class="list-disc pl-4 mb-4">
          <li>Directly from you when you provide it to us.</li>
          <li>Indirectly from you (e.g., from observing your actions on our website or from information your computer or mobile device transmits when interacting with our website or mobile applications, among other things).</li>
          <li>From third-party business partners such as analytics providers, advertising networks, and data brokers.</li>
        </ul>
        `,
        sectionId: "2",
      }),
    ],
    undefined,
    2
  ),

  // USE OF PERSONAL INFORMATION
  createContentBlock(
    "Use of Personal Information",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p class="mb-4">We may use or disclose the personal information we collect for one or more of the business or commercial purposes described in our Privacy Policy.</p>
        `,
        sectionId: "3",
      }),
    ],
    undefined,
    3
  ),

  // DISCLOSURE OF PERSONAL INFORMATION
  createContentBlock(
    "Disclosure of Personal Information",
    "In the preceding twelve (12) months, we have disclosed the following categories of personal information for business purposes to the following categories of third parties:",
    [
      createSubContent({
        title: "",
        html: `
        <table class="min-w-full border-collapse border border-gray-300 mb-4">
          <tr class="bg-gray-100">
            <th class="border border-gray-300 p-2 text-left">Category of Personal Information</th>
            <th class="border border-gray-300 p-2 text-left">Categories of Third Parties</th>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">A. Identifiers</td>
            <td class="border border-gray-300 p-2">Service providers, affiliates, business partners, advertising networks, data analytics providers, social media platforms</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">B. California Customer Records personal information categories</td>
            <td class="border border-gray-300 p-2">Service providers, payment processors, affiliates</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">C. Commercial information</td>
            <td class="border border-gray-300 p-2">Service providers, affiliates, business partners, data analytics providers</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">D. Internet or other similar network activity</td>
            <td class="border border-gray-300 p-2">Service providers, advertising networks, data analytics providers</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">E. Geolocation data</td>
            <td class="border border-gray-300 p-2">Service providers, data analytics providers</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">F. Professional or employment-related information</td>
            <td class="border border-gray-300 p-2">Service providers, affiliates</td>
          </tr>
          <tr>
            <td class="border border-gray-300 p-2">G. Inferences</td>
            <td class="border border-gray-300 p-2">Service providers, advertising networks, data analytics providers</td>
          </tr>
        </table>
        `,
        sectionId: "4",
      }),
    ],
    undefined,
    4
  ),

  // SALE OR SHARING OF PERSONAL INFORMATION
  createContentBlock(
    "Sale or Sharing of Personal Information",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p class="mb-4">In the preceding twelve (12) months, we have shared the following categories of personal information for cross-context behavioral advertising purposes:</p>
        <ul class="list-disc pl-4 mb-4">
          <li>Identifiers</li>
          <li>Internet or other similar network activity</li>
          <li>Geolocation data</li>
          <li>Inferences</li>
        </ul>
        <p class="mb-4">We do not sell or share the personal information of consumers we actually know are less than 16 years of age.</p>
        `,
        sectionId: "5",
      }),
    ],
    undefined,
    5
  ),

  // YOUR RIGHTS UNDER THE CCPA/CPRA
  createContentBlock(
    "Your Rights Under the CCPA/CPRA",
    "If you are a California resident, you have the following rights:",
    [
      createSubContent({
        title: "Right to Know and Access",
        content:
          "You have the right to request that we disclose certain information to you about our collection, use, disclosure, and sale or sharing of your personal information over the past 12 months, including:",
        listItems: [
          "The categories of personal information we collected about you",
          "The categories of sources for the personal information",
          "Our business or commercial purpose for collecting, selling, or sharing that personal information",
          "The categories of third parties with whom we share, sold, or shared that personal information",
          "The specific pieces of personal information we collected about you",
        ],
        sectionId: "6",
        subSectionId: "1",
      }),
      createSubContent({
        title: "Right to Delete",
        content:
          "You have the right to request that we delete personal information that we collected from you and retained, subject to certain exceptions.",
        sectionId: "6",
        subSectionId: "2",
      }),
      createSubContent({
        title: "Right to Correct",
        content:
          "You have the right to request that we correct inaccurate personal information that we maintain about you.",
        sectionId: "6",
        subSectionId: "3",
      }),
      createSubContent({
        title: "Right to Opt-Out",
        content:
          'You have the right to opt-out of the sale or sharing of your personal information for cross-context behavioral advertising purposes. To exercise this right, click on the "Do Not Sell or Share My Personal Information" link on our website homepage.',
        sectionId: "6",
        subSectionId: "4",
      }),
      createSubContent({
        title: "Right to Limit Use of Sensitive Personal Information",
        content:
          "We do not use or disclose sensitive personal information for purposes other than those specified in the CPRA.",
        sectionId: "6",
        subSectionId: "5",
      }),
      createSubContent({
        title: "Non-Discrimination",
        content:
          "We will not discriminate against you for exercising any of your CCPA/CPRA rights.",
        sectionId: "6",
        subSectionId: "6",
      }),
    ],
    undefined,
    6
  ),

  // HOW TO EXERCISE YOUR RIGHTS
  createContentBlock(
    "How to Exercise Your Rights",
    "To exercise your rights described above, please submit a verifiable consumer request to us by either:",
    [
      createSubContent({
        title: "",
        html: `
        <ul class="list-disc pl-4 mb-4">
          <li>Calling us at <a href="tel:+18182858209" class="text-system-primary hover:underline">+1 (818) 285 8209</a></li>
          <li>Emailing us at <a href="mailto:privacy@wirelessworld.us" class="text-system-primary hover:underline">privacy@wirelessworld.us</a></li>
          <li>Visiting our website at <a href="https://wirelessworld.us/privacypolicy" class="text-system-primary hover:underline">wirelessworld.us/privacypolicy</a></li>
        </ul>
        <p class="mb-4">Only you, or someone legally authorized to act on your behalf, may make a verifiable consumer request related to your personal information.</p>
        <p class="mb-4">You may only make a verifiable consumer request for access or data portability twice within a 12-month period.</p>
        <p class="mb-4">To verify your identity when you make a request, we will ask you to provide information that matches information we have on file about you. In some cases, we may also ask you to provide a signed declaration under penalty of perjury confirming your identity.</p>
        <p class="mb-4">We endeavor to respond to a verifiable consumer request within forty-five (45) days of its receipt. If we require more time, we will inform you of the reason and extension period in writing.</p>
        `,
        sectionId: "7",
      }),
    ],
    undefined,
    7
  ),

  // AUTHORIZED AGENT
  createContentBlock(
    "Authorized Agent",
    "",
    [
      createSubContent({
        title: "",
        content:
          "You may designate an authorized agent to make a request on your behalf. To do so, you must provide the authorized agent with written permission to make a request on your behalf, and we may require you to verify your identity directly with us. Alternatively, the authorized agent must provide proof that they have a power of attorney pursuant to California Probate Code sections 4000 to 4465.",
        sectionId: "8",
      }),
    ],
    undefined,
    8
  ),

  // CONTACT INFORMATION
  createContentBlock(
    "Contact Information",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p class="mb-4">For questions or concerns about our privacy policies and practices, please contact us at:</p>
        <p class="mb-4">Wireless World<br>16141 Leadwell Street<br>Van Nuys, CA 91406, USA</p>
        <p class="mb-4">Email:<br><a href="mailto:privacy@wirelessworld.us" class="text-system-primary hover:underline">privacy@wirelessworld.us</a></p>
        <p class="mb-4">Phone:<br><a href="tel:+18182858209" class="text-system-primary hover:underline">+1 (818) 285 8209</a></p>
        `,
        sectionId: "9",
      }),
    ],
    undefined,
    9
  ),
];
